<template>
  <div class="outofStockModal">
  	   <div class="title"> {{ $t('outOfStock') }} </div>
  	   <div v-html="$t('outOfStockText')"  class="message raleway"></div>

       <div class="articles">

       		<div v-if="stockArticles" v-for="article in stockArticles" class="article">

       			<div class="image">
       				<div class="inner"> <img v-bind:src="getArticleImage(article)"> </div>
       			</div>

       			<div @click="watchProduct(article)" class="button small watch"> Bevaka </div>

       		</div>

       </div> <!-- articles -->

  </div> 
</template>

<script>

export default {


	computed: {  
		stockArticles(){
			return window.vueInstance.$store.state.cartNoStock
		}
	},

	methods: {

		watchProduct(article){

			window.apiHandler['specificArticles'](function(data){

				if(data && data.products && typeof data.products[0] != 'undefined'){
					 window.open("https://desenio.co.uk/p/"+ data.products[0].URL, '_blank').focus();
				}

			},
			{
				articles: [article.productID]
			});

		}

	}

}
</script>

<style>

.modalContainer .modal{
	width: 50%;
	margin-left: -25%;
}

.outofStockModal{

  .message{
    margin-top: 25px;
    text-align: center;
    font-size: 13px;
    text-transform: uppercase;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    line-height: 26px;

    @media screen and (max-width: 900px) {
    	margin-top: 10px;
    }

  }

  a{
    color: black;
  }

  .confirmButtons{
    margin-top: 20px;
  }

  .primaryButton{
    background: black;
    color: white;
  }

  .articles{
  	margin-top: 30px;
  	min-height: 200px;
  }

  .article{

  	float: left; 
  	width: 25%;
  	text-align: center;

  	@media screen and (max-width: 900px) {
    	width: 18%;
  	}

  	.image{
  		display: table;
  		height: 100px;
  		width: 100%;

  		.inner{
  			display: table-cell;
  			vertical-align: middle;
  			text-align: center;
  		}
  	}

  	img{
  		max-width: 100px;

  		@media screen and (max-width: 900px) {
  		    max-width: 79px;
  		}
  	}

  	.name{
  		font-size: 13px;

  		@media screen and (max-width: 900px) {
  			font-size: 11px;
  		}
  	}


  	.watch{
  		margin-top: 10px;
  	}
  }

}

</style>



// WEBPACK FOOTER //
// NoStock.vue?5269170b